import { Component, Input, OnInit, ViewEncapsulation, HostListener } from "@angular/core";
import { Chart } from 'src/app/shared/utils/chart-setup';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ReportService } from "src/app/core/services/report/report.service";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { debounceTime, Subject } from "rxjs";

@Component({
    selector: "app-informe-admin",
    templateUrl: "./informe-admin.component.html",
    styleUrls: ["./informe-admin.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('accordion', [
            state('open', style({
                width: 'auto',
                transform: 'translateY(0)',
                overflow: 'initial',
                right: '10px'
            })),
            state('closed', style({
                width: '0',
                overflow: 'hidden',
                transform: 'translateY(-500px)',
                right: '-200px'
            })),
            transition('open <=> closed', [
                animate('0.3s ease-out')
            ]),
        ]),
        trigger('accordion2', [
            state('in', style({
                width: 'auto',
                transform: 'translateX(0px)',
                overflow: 'initial',
                left: '10px'
            })),
            state('out', style({
                width: '0',
                overflow: 'hidden',
                transform: 'translateX(-500px)',
                left: '-200px'
            })),
            transition('in <=> out', [
                animate('0.3s ease-in-out')
            ]),
        ])
    ],
    standalone: false
})
export class InformeAdminComponent implements OnInit {
    @Input() allDatasets: any[] = [];
    @Input() datasetsImported: any;
    @Input() labelsImported: any;

    selectedLabel = null; // Variable para guardar el elemento seleccionado
    verBotonesGraficas: number = 0;
    consultas: any[] = [
        //editor
        { id: 1, title: this.translateService.instant("REPORT.EDITORSACTIVITY"), role: 1 },
        //{ id: 1, title: this.translateService.instant("REPORT.EDITORSSIGNED"), role: 1 },
        //estudiante
        { id: 2, title: this.translateService.instant("REPORT.STUDENTSACTIVITY"), role: 2 },
        //{ id: 2, title: this.translateService.instant("REPORT.STUDENTSSIGNED"), role: 2 },
        //profe        
        { id: 3, title: this.translateService.instant("REPORT.TEACHERSACTIVITY"), role: 3 },
        //{ id: 3, title: this.translateService.instant("REPORT.TEACHERSSIGNED"), role: 3 },
        //padre        
        { id: 4, title: this.translateService.instant("REPORT.PARENTSSIGNED"), role: 4 },
        //grupos
        { id: 5, title: this.translateService.instant("REPORT.GROUPSACTIVITY"), role: 0 },
    ];
    consulta: number = 0;
    consultaID: number | null = null;
    role: number = 0;

    usersList: any[] = [];
    originalUsersList: any[] = [];
    sortCriteria: 'time' | 'challenges' | 'projects' | 'ideographs' | 'ideas' | 'activities' | 'timeActivities' | 'timeIdeas' = 'time';
    isMobile: boolean = false;
    isMobile1: boolean = false;
    isMenuOpen: boolean = false;
    accordionOpen: boolean = false;
    accordionOpen2: boolean = false;

    step: number = 1;

    formulario: UntypedFormGroup;
    originalDatasets: any[] = [];

    // Chart related properties
    currentMonthLabel: string = '';
    currentYear: number = 0;
    currentMonth: number = 0;
    expandedUserIndex: number = -1;
    activeChart: any = null;
    isProcessing = false;
    noDataMessage: boolean = false;

    // Caches para evitar llamadas repetidas a la API
    private cacheUsersList = new Map<string, any[]>();
    private cacheInformeAdmin = new Map<string, any>();

    private unsubscribe$ = new Subject<void>();
    loading: boolean = false;
    mensajes = [
        this.translateService.instant("LOADING_MESSAGES.MSG1"),
        this.translateService.instant("LOADING_MESSAGES.MSG2"),
        this.translateService.instant("LOADING_MESSAGES.MSG3"),
        this.translateService.instant("LOADING_MESSAGES.MSG4"),
        this.translateService.instant("LOADING_MESSAGES.MSG5"),
        this.translateService.instant("LOADING_MESSAGES.MSG6"),
        this.translateService.instant("LOADING_MESSAGES.MSG7"),
        this.translateService.instant("LOADING_MESSAGES.MSG8"),
        this.translateService.instant("LOADING_MESSAGES.MSG9"),
        this.translateService.instant("LOADING_MESSAGES.MSG10"),
        this.translateService.instant("LOADING_MESSAGES.MSG11"),
        this.translateService.instant("LOADING_MESSAGES.MSG12"),
        this.translateService.instant("LOADING_MESSAGES.MSG13"),
        this.translateService.instant("LOADING_MESSAGES.MSG14"),
        this.translateService.instant("LOADING_MESSAGES.MSG15"),
        this.translateService.instant("LOADING_MESSAGES.MSG16"),
        this.translateService.instant("LOADING_MESSAGES.MSG17"),
        this.translateService.instant("LOADING_MESSAGES.MSG18"),
        this.translateService.instant("LOADING_MESSAGES.MSG19"),
        this.translateService.instant("LOADING_MESSAGES.MSG20"),
        this.translateService.instant("LOADING_MESSAGES.MSG21"),
        this.translateService.instant("LOADING_MESSAGES.MSG22"),
        this.translateService.instant("LOADING_MESSAGES.MSG23"),
        this.translateService.instant("LOADING_MESSAGES.MSG24"),
        this.translateService.instant("LOADING_MESSAGES.MSG25"),
        this.translateService.instant("LOADING_MESSAGES.MSG26"),
        this.translateService.instant("LOADING_MESSAGES.MSG27"),
        this.translateService.instant("LOADING_MESSAGES.MSG28"),
        this.translateService.instant("LOADING_MESSAGES.MSG29"),
        this.translateService.instant("LOADING_MESSAGES.MSG30"),
        this.translateService.instant("LOADING_MESSAGES.MSG31"),
        this.translateService.instant("LOADING_MESSAGES.MSG32"),
        this.translateService.instant("LOADING_MESSAGES.MSG33"),
        this.translateService.instant("LOADING_MESSAGES.MSG34"),
        this.translateService.instant("LOADING_MESSAGES.MSG35"),
        this.translateService.instant("LOADING_MESSAGES.MSG36"),
        this.translateService.instant("LOADING_MESSAGES.MSG37"),
        this.translateService.instant("LOADING_MESSAGES.MSG38"),
        this.translateService.instant("LOADING_MESSAGES.MSG39"),
        this.translateService.instant("LOADING_MESSAGES.MSG40"),
        this.translateService.instant("LOADING_MESSAGES.MSG41"),
        this.translateService.instant("LOADING_MESSAGES.MSG42"),
        this.translateService.instant("LOADING_MESSAGES.MSG43"),
        this.translateService.instant("LOADING_MESSAGES.MSG44"),
        this.translateService.instant("LOADING_MESSAGES.MSG45"),
        this.translateService.instant("LOADING_MESSAGES.MSG46"),
        this.translateService.instant("LOADING_MESSAGES.MSG47"),
        this.translateService.instant("LOADING_MESSAGES.MSG48"),
        this.translateService.instant("LOADING_MESSAGES.MSG49"),
        this.translateService.instant("LOADING_MESSAGES.MSG50")
    ];
    mensajeActual: string = '';
    intervaloMensajes: any;

    constructor(
        public activeModal: NgbActiveModal,
        private translateService: TranslateService,
        private reportService: ReportService,
        private formBuild: UntypedFormBuilder,
    ) {
        this.formulario = this.formBuild.group({
            filtrado: [""],
            userFilter: [""]
        });
        this.setupSearchListener();
    }

    ngOnInit() {
        this.consultaID = this.consulta;
        this.isMobile = window.innerWidth < 1200;
        this.isMobile1 = window.innerWidth < 1350;
        if (this.consulta < 9) {
            this.verBotonesGraficas = 1;
        } else if (this.consulta == 9) {
            this.verBotonesGraficas = 2;
        }

        if (!this.allDatasets || this.allDatasets.length === 0) {
            this.onConsultaChange();
        } else {
            this.openLastRecord();
            // guarda copia original para usar en el filtro
            this.originalDatasets = JSON.parse(JSON.stringify(this.allDatasets));
        }
    }

    ngOnDestroy() {
        if (this.activeChart) {
            this.activeChart.destroy();
        }
        this.cacheUsersList.clear();
        this.cacheInformeAdmin.clear();
    }

    closeModal(sendData?: any) {
        this.activeModal.close();
    }

    @HostListener("window:resize", ["$event"])
    onResize(event: any): void {
        if (window.innerWidth <= 1200) {
            this.isMobile = true;
        } else {
            this.isMobile = false;
        }

        if (window.innerWidth <= 1350) {
            this.isMobile1 = true;
        } else {
            this.isMobile1 = false;
        }
    }

    viewChildren2(i: number, skipDebounce: boolean = false) {
        if (!skipDebounce) {
            if (this.isProcessing) return;
            this.isProcessing = true;
            setTimeout(() => { this.isProcessing = false }, 300);
        }
        this.allDatasets[i].childrenVisible = !this.allDatasets[i].childrenVisible;
        for (let index = 0; index < this.allDatasets[i].children.length; index++) {
            this.allDatasets[i].children[index].childrenVisible = false;
        }
    }
    viewChildren3(i: number, j: number, skipDebounce: boolean = false) {
        if (!skipDebounce) {
            if (this.isProcessing) return;
            this.isProcessing = true;
            setTimeout(() => { this.isProcessing = false }, 300);
        }
        this.allDatasets[i].children[j].childrenVisible = !this.allDatasets[i].children[j].childrenVisible;
    }
    closeTree() {
        if (this.allDatasets != null && this.allDatasets.length > 0) {
            for (let i = 0; i < this.allDatasets.length; i++) {
                this.allDatasets[i].childrenVisible = false;
                if (this.allDatasets[i].children != null && this.allDatasets[i].children.length > 0) {
                    for (let j = 0; j < this.allDatasets[i].children.length; j++) {
                        this.allDatasets[i].children[j].childrenVisible = false;
                    }
                }
            }
        }
    }

    openLastRecord() {
        if (!this.allDatasets || this.allDatasets.length === 0) return;

        const lastI = this.allDatasets.length - 1;
        // Abrimos primer nivel
        this.viewChildren2(lastI, true);

        const root = this.allDatasets[lastI];
        if (root.children && root.children.length > 0) {
            const lastJ = root.children.length - 1;
            // Abrimos segundo nivel
            this.viewChildren3(lastI, lastJ, true);

            const child = root.children[lastJ];
            if (child.children && child.children.length > 0) {
                const lastK = child.children.length - 1;
                const grandChild = child.children[lastK];
                // Seleccionamos tercer nivel
                this.viewData(grandChild.data, grandChild, 3, child, true);
            } else {
                // Seleccionamos segundo nivel
                this.viewData(child.data, child, 2, null, true);
            }
        } else {
            // Seleccionamos primer nivel
            this.viewData(root.data, root, 1, null, true);
        }
    }

    ocultarTodo() {
        //ocultamos la grafica de barras
        const div = document.getElementById("barras");
        if (div) {
            div.style.display = "none";
        }
        //ocultamos la grafica de barras agrupadas
        const div2 = document.getElementById("barras_group");
        if (div2) {
            div2.style.display = "none";
        }
    }

    viewData(data: any, select: any, level: number, parent: any = null, skipDebounce: boolean = false) {
        if (!skipDebounce) {
            if (this.isProcessing) return;
            this.isProcessing = true;
            setTimeout(() => { this.isProcessing = false }, 300);
        }
        this.step = level;
        this.ocultarTodo();
        this.selectedLabel = select;
        this.noDataMessage = false;

        // Verificar si hay datos para mostrar
        const hasData = data != null && Array.isArray(data) && data.length > 0;

        if (level === 3) {
            this.verBotonesGraficas = 0;
            this.datasetsImported = null;
            this.usersList = [];

            // Reset expanded state
            this.expandedUserIndex = -1;
            if (this.activeChart) {
                this.activeChart.destroy();
                this.activeChart = null;
            }

            if (parent) {
                const year = parseInt(parent.label);
                const month = this.getMonthFromLabel(select.label);
                this.currentMonthLabel = select.label;
                this.currentYear = year;
                this.currentMonth = month;

                // Si el nodo padre (año) indica 0 actividad para este mes, mostrar mensaje
                if (!hasData) {
                    this.noDataMessage = true;
                    return;
                }

                const cacheKey = `${month}-${year}-${this.role}-${this.consultaID}`;
                const cached = this.cacheUsersList.get(cacheKey);
                if (cached) {
                    // Usar datos cacheados
                    this.usersList = structuredClone(cached);
                    this.originalUsersList = structuredClone(cached);
                    this.formulario.get('userFilter')?.setValue('', { emitEvent: false });
                    this.sortUsers();
                } else {
                    this.loading = true;
                    this.iniciarCambioMensajes();
                    this.reportService.getResumeActivityForAdminByMonthAndYear(month, year, this.role, this.consultaID).subscribe(res => {
                        this.cancelarLoading();
                        const data = res.data ? res.data : res;
                        this.cacheUsersList.set(cacheKey, structuredClone(data));
                        this.usersList = data;
                        this.originalUsersList = structuredClone(data);
                        this.formulario.get('userFilter')?.setValue('', { emitEvent: false });
                        this.sortUsers();
                    });
                }
            }
            return;
        } else {
            this.usersList = [];
        }

        if (!hasData) {
            this.noDataMessage = true;
            this.datasetsImported = null;
            this.verBotonesGraficas = 0;
            return;
        }

        let aux = this.verBotonesGraficas;
        if (aux === 0) {
            aux = (this.consulta == 9) ? 2 : 1;
        }

        this.labelsImported = [this.selectedLabel];
        this.datasetsImported = data;
        this.verBotonesGraficas = 0;
        this.loading = true;
        this.iniciarCambioMensajes();
        setTimeout(() => {
            this.cancelarLoading();
            if (aux == 1) {
                this.verBarras();
            } else if (aux == 2) {
                this.verBarrasGroup();
            }
        }, 100);
    }

    getMonthFromLabel(label: string): number {
        const months = [
            'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
            'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
        ];
        return months.indexOf(this.normalizeText(label).toLowerCase()) + 1;
    }

    getDatasets(dataIn: any[]) {
        //primero creamos los labels
        let datasets = [];
        let labels = [];
        let cant = 0;
        if (this.consultaID == 9) {
            labels = ['Proyectos', 'Ideografos', 'Ideas', 'Actividades'];
            cant = 4;
        }
        //ahora creamos el dataset
        for (let index = 0; index < cant; index++) {
            const data = [];
            for (let index2 = 0; index2 < dataIn.length; index2++) {
                const element = dataIn[index2].data[index];
                data.push(element);
            }
            const newDataset = {
                label: labels[index],
                borderWidth: 1,
                data: data,
            };
            datasets.push(newDataset);
        }
        return datasets;
    }

    verBarras() {
        //mostramos la grafica de barras
        const div = document.getElementById("barras");
        if (div) {
            div.style.display = "block";
        }
        //mostramos la grafica de barras agrupadas
        const div2 = document.getElementById("barras_group");
        if (div2) {
            div2.style.display = "none";
        }
        this.verBotonesGraficas = 1;
        this.accordionOpen = false;
    }
    verBarrasGroup() {
        //mostramos la grafica de barras agrupadas
        const div = document.getElementById("barras_group");
        if (div) {
            div.style.display = "block";
        }
        //mostramos la grafica de barras
        const div2 = document.getElementById("barras");
        if (div2) {
            div2.style.display = "none";
        }
        this.verBotonesGraficas = 2;
        this.accordionOpen = false;
    }

    toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
        this.accordionOpen = false;
        this.accordionOpen2 = false;
    }

    toggleAccordion() {
        this.isMenuOpen = false;
        this.accordionOpen = !this.accordionOpen;
        this.accordionOpen2 = false;
    }

    toggleAccordion2() {
        this.isMenuOpen = false;
        this.accordionOpen = false;
        this.accordionOpen2 = !this.accordionOpen2;
    }

    onConsultaChange() {
        this.datasetsImported = null;
        this.allDatasets = [];
        this.noDataMessage = false;
        if (this.consultaID == 1 || this.consultaID == 5) {
            this.role = 1;
        } else if (this.consultaID == 2 || this.consultaID == 6) {
            this.role = 2;
        } else if (this.consultaID == 3 || this.consultaID == 7) {
            this.role = 3;
        } else if (this.consultaID == 4 || this.consultaID == 8) {
            this.role = 4;
        }

        const cacheKey = `informe-${this.role}-${this.consultaID}`;
        const cached = this.cacheInformeAdmin.get(cacheKey);

        if (cached) {
            // Usar datos cacheados
            this.originalDatasets = structuredClone(cached);
            this.allDatasets = structuredClone(cached);
            this.openLastRecord();
        } else {
            this.loading = true;
            this.iniciarCambioMensajes();
            this.reportService.getInformeAdmin(this.role, this.consultaID).subscribe(
                res => {
                    this.cancelarLoading();
                    if (res.data) {
                        this.cacheInformeAdmin.set(cacheKey, structuredClone(res.data));
                        this.originalDatasets = structuredClone(res.data);
                        this.allDatasets = res.data;
                        this.openLastRecord();
                    }
                }
            );
        }
    }

    verDetalle(event: { datasetIndex: number; index: number }) {
        if (this.step < 3 && this.selectedLabel && this.selectedLabel.children && this.selectedLabel.children.length > event.index) {
            const child = this.selectedLabel.children[event.index];
            this.viewData(child.data, child, this.step + 1, this.selectedLabel);
        }
    }

    setupSearchListener() {
        this.formulario
            .get("filtrado")
            .valueChanges.pipe(debounceTime(800)) //TIEMPO QUE TENEMOS PARA ESCRIBIR EN EL FILTRO EN MILISEGUNDOS
            .subscribe(() => {
                this.filtrarPorNombre();
            });

        this.formulario
            .get("userFilter")
            .valueChanges.pipe(debounceTime(500))
            .subscribe(() => {
                this.filtrarUsuarios();
            });
    }

    filtrarUsuarios() {
        const val = this.formulario.get("userFilter")?.value || "";

        // Collapse expanded details when filtering to avoid index mismatches
        this.expandedUserIndex = -1;
        if (this.activeChart) {
            this.activeChart.destroy();
            this.activeChart = null;
        }

        if (!val) {
            this.usersList = structuredClone(this.originalUsersList);
            return;
        }

        const term = this.normalizeText(val.toLowerCase());
        this.usersList = this.originalUsersList.filter(user => {
            const fullName = this.normalizeText((user.name + ' ' + user.surname).toLowerCase());
            return fullName.includes(term);
        });
        this.sortUsers();
    }

    // Getter para filtrar consultas según el rol actual
    get filteredConsultas(): any[] {
        if (this.role === 0) {
            if (this.consultaID > 5) {
                return this.consultas;
            }
        }
        return this.consultas.filter(consulta => consulta.role === this.role);
    }

    setSort(criteria: 'time' | 'challenges' | 'projects' | 'ideographs' | 'ideas' | 'activities' | 'timeActivities' | 'timeIdeas') {
        if (this.isProcessing) return;
        this.isProcessing = true;
        setTimeout(() => { this.isProcessing = false }, 300);
        if (this.sortCriteria === criteria) return;
        this.sortCriteria = criteria;

        // Collapse to avoid index issues
        this.expandedUserIndex = -1;
        if (this.activeChart) {
            this.activeChart.destroy();
            this.activeChart = null;
        }

        this.sortUsers();
    }

    sortUsers() {
        if (this.sortCriteria === 'time') {
            this.usersList.sort((a, b) => (b.tiempoActivoTotal_ms || 0) - (a.tiempoActivoTotal_ms || 0));
        } else if (this.sortCriteria === 'challenges') {
            this.usersList.sort((a, b) => (b.desafiosRealizados || 0) - (a.desafiosRealizados || 0));
        } else if (this.sortCriteria === 'projects') {
            this.usersList.sort((a, b) => (b.proyectosCreados || 0) - (a.proyectosCreados || 0));
        } else if (this.sortCriteria === 'ideographs') {
            this.usersList.sort((a, b) => (b.grafosCreados || 0) - (a.grafosCreados || 0));
        } else if (this.sortCriteria === 'ideas') {
            this.usersList.sort((a, b) => (b.ideasCreadas || 0) - (a.ideasCreadas || 0));
        } else if (this.sortCriteria === 'activities') {
            this.usersList.sort((a, b) => (b.actividadesCreadas || 0) - (a.actividadesCreadas || 0));
        } else if (this.sortCriteria === 'timeActivities') {
            this.usersList.sort((a, b) => (b.tiempoActividades_ms || 0) - (a.tiempoActividades_ms || 0));
        } else if (this.sortCriteria === 'timeIdeas') {
            this.usersList.sort((a, b) => (b.tiempoIdeas_ms || 0) - (a.tiempoIdeas_ms || 0));
        }
    }

    filtrarPorNombre() {
        const searchValue = this.normalizeText(
            this.formulario.get("filtrado")?.value?.toLowerCase() || ""
        );
        if (!searchValue) {
            // Si está vacío, restauramos todo desde la copia original
            this.allDatasets = structuredClone(this.originalDatasets);
            return;
        }
        const resultado = this.originalDatasets
            .map(label_1 => {
                const filteredChildren = label_1.children?.filter(label_2 =>
                    this.normalizeText(label_2.label.toLowerCase()).includes(searchValue)
                ) || [];

                if (filteredChildren.length > 0) {
                    return {
                        ...label_1,
                        childrenVisible: true,
                        children: filteredChildren.map(child => ({
                            ...child,
                            childrenVisible: false
                        }))
                    };
                }
                return null;
            })
            .filter(item => item !== null);
        this.allDatasets = resultado;
    }


    /**
     * Un nodo esta deshabilitado si no tiene data propia
     * Y no tiene hijos, o todos sus hijos estan deshabilitados (recursivo).
     */
    isNodeDisabled(node: any): boolean {
        const hasOwnData = node.data != null && Array.isArray(node.data) && node.data.length > 0;
        const hasChildren = node.children != null && node.children.length > 0;

        if (hasOwnData) return false;
        if (!hasChildren) return true;

        return node.children.every(child => this.isNodeDisabled(child));
    }

    normalizeText(text) {
        return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    formatTime(ms: number): string {
        if (!ms) return '0h 0m 0s';
        const seconds = Math.floor((ms / 1000) % 60);
        const minutes = Math.floor((ms / (1000 * 60)) % 60);
        const hours = Math.floor((ms / (1000 * 60 * 60)));

        return `${hours}h ${minutes}m ${seconds}s`;
    }

    clearSearch() {
        this.formulario.get('filtrado')?.setValue('');
    }

    clearUserFilter() {
        this.formulario.get('userFilter')?.setValue('');
    }

    toggleExpandedUser(index: number, user: any) {
        if (this.isProcessing) return;
        this.isProcessing = true;
        setTimeout(() => { this.isProcessing = false }, 300);

        if (this.expandedUserIndex === index) {
            // Collapse
            this.expandedUserIndex = -1;
            if (this.activeChart) {
                this.activeChart.destroy();
                this.activeChart = null;
            }
        } else {
            // Expand new
            this.expandedUserIndex = index;
            if (this.activeChart) {
                this.activeChart.destroy();
                this.activeChart = null;
            }
            // Wait for DOM to update
            setTimeout(() => {
                this.renderDailyActivityChart(index, user);
                if (this.role === 2) {
                    this.renderStudentSpecificChart(index, user);
                } else if (this.role === 1) {
                    this.renderEditorSpecificChart(index, user);
                }
            }, 100);
        }
    }

    renderDailyActivityChart(index: number, user: any) {
        if (!user.tiempoActivoDiario_ms || user.tiempoActivoDiario_ms.length === 0) return;

        const canvasId = 'chart-user-' + index;
        const canvas = document.getElementById(canvasId) as HTMLCanvasElement;

        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        // Prepare data
        const monthShort = this.currentMonthLabel ? this.currentMonthLabel.substring(0, 3).toLowerCase() : '';
        const days = Array.from({ length: user.tiempoActivoDiario_ms.length }, (_, i) => `${i + 1}-${monthShort}`);

        // Helper for safe data
        const getSafeData = (arr: any[]) => arr ? arr.map(v => v || 0) : new Array(days.length).fill(0);

        // Time data
        const dataInMs = getSafeData(user.tiempoActivoDiario_ms);
        const maxVal = Math.max(...dataInMs);

        const timeFormatter = (ms: number) => {
            if (!ms) return '0h 0m 0s';
            const seconds = Math.floor((ms / 1000) % 60);
            const minutes = Math.floor((ms / (1000 * 60)) % 60);
            const hours = Math.floor((ms / (1000 * 60 * 60)));
            return `${hours}h ${minutes}m ${seconds}s`;
        };

        const datasets: any[] = [
            {
                label: 'Tiempo Total',
                data: dataInMs,
                borderColor: '#023e8a', // Cool Dark Blue
                backgroundColor: 'rgba(2, 62, 138, 0.1)',
                borderWidth: 2,
                fill: true,
                tension: 0.4,
                pointRadius: 3,
                yAxisID: 'y',
            }
        ];

        let y1Options: any = {};

        if (this.role === 1) { // Editor
            // For role 1, we now only show the time chart in the first canvas.
            // The creation stats are moved to renderEditorSpecificChart
            y1Options = { display: false };
        } else {
            // Default behavior (Students, Professors)
            const challengesData = getSafeData(user.desafiosDiarios);
            const maxChallenges = Math.max(...challengesData);

            datasets.push({
                label: 'Desafíos Realizados',
                data: challengesData,
                type: 'bar',
                borderColor: '#e85d04', // Dark Orange
                backgroundColor: 'rgba(232, 93, 4, 0.6)',
                borderWidth: 1,
                fill: true,
                tension: 0.4,
                pointRadius: 3,
                yAxisID: 'y1',
            });

            y1Options = {
                type: 'linear',
                display: true,
                position: 'right',
                beginAtZero: true,
                max: maxChallenges > 0 ? maxChallenges : undefined,
                title: {
                    display: true,
                    text: 'Desafíos (unidades)',
                    color: '#e85d04'
                },
                grid: {
                    drawOnChartArea: false,
                },
                ticks: {
                    color: '#e85d04',
                    maxTicksLimit: 3,
                    stepSize: maxChallenges > 0 ? maxChallenges / 2 : undefined,
                    callback: (value) => Math.floor(Number(value))
                }
            };
        }

        this.activeChart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: days,
                datasets: datasets
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                    mode: 'index',
                    intersect: false,
                },
                plugins: {
                    datalabels: {
                        display: false
                    },
                    legend: {
                        display: true
                    },
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                if (context.dataset.yAxisID === 'y') {
                                    return context.dataset.label + ': ' + timeFormatter(context.raw as number);
                                } else {
                                    return context.dataset.label + ': ' + context.raw;
                                }
                            }
                        }
                    }
                },
                scales: {
                    y: {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        beginAtZero: true,
                        max: maxVal > 0 ? maxVal : undefined,
                        title: {
                            display: true,
                            text: 'Tiempo Total',
                            color: '#023e8a'
                        },
                        ticks: {
                            color: '#023e8a',
                            maxTicksLimit: 3,
                            stepSize: maxVal > 0 ? maxVal / 2 : undefined,
                            callback: (value) => {
                                return timeFormatter(Number(value));
                            }
                        }
                    },
                    y1: y1Options,
                    x: {
                        title: {
                            display: false,
                            text: 'Día'
                        },
                        grid: {
                            color: (context) => {
                                if (context.tick && typeof context.tick.value === 'number') {
                                    const day = context.tick.value + 1;
                                    if (this.currentYear && this.currentMonth) {
                                        const date = new Date(this.currentYear, this.currentMonth - 1, day);
                                        if (date.getDay() === 0) return '#555555';
                                    }
                                }
                                return 'rgba(0, 0, 0, 0.1)';
                            },
                            // @ts-ignore
                            borderDash: (context) => {
                                if (context.tick && typeof context.tick.value === 'number') {
                                    const day = context.tick.value + 1;
                                    if (this.currentYear && this.currentMonth) {
                                        const date = new Date(this.currentYear, this.currentMonth - 1, day);
                                        if (date.getDay() === 0) return [5, 5];
                                    }
                                }
                                return [];
                            }
                        }
                    }
                }
            }
        });
    }

    renderStudentSpecificChart(index: number, user: any) {
        if (!user.tiempoActivoDiario_ms) return; // Basic check

        const canvasId = 'chart-user-2-' + index;
        const canvas = document.getElementById(canvasId) as HTMLCanvasElement;

        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        const monthShort = this.currentMonthLabel ? this.currentMonthLabel.substring(0, 3).toLowerCase() : '';
        const days = Array.from({ length: user.tiempoActivoDiario_ms.length }, (_, i) => `${i + 1}-${monthShort}`);
        const getSafeData = (arr: any[]) => arr ? arr.map(v => v || 0) : new Array(days.length).fill(0);

        const ideasData = getSafeData(user.tiempoIdeasDiario_ms);
        const actividadesTimeData = getSafeData(user.tiempoActividadesDiario_ms);
        // Assuming user.actividadesRealizadasDiarias exists for the count. If not, this defaults to 0s, preventing errors.
        const actividadesCountData = getSafeData(user.actividadesRealizadasDiarias);

        const maxValTime = Math.max(...ideasData, ...actividadesTimeData);
        const maxValCount = Math.max(...actividadesCountData);

        const timeFormatter = (ms: number) => {
            if (!ms) return '0h 0m 0s';
            const seconds = Math.floor((ms / 1000) % 60);
            const minutes = Math.floor((ms / (1000 * 60)) % 60);
            const hours = Math.floor((ms / (1000 * 60 * 60)));
            return `${hours}h ${minutes}m ${seconds}s`;
        };

        new Chart(ctx, {
            type: 'line',
            data: {
                labels: days,
                datasets: [
                    {
                        label: 'Tiempo Ideas',
                        data: ideasData,
                        borderColor: '#023e8a', // Royal Blue
                        backgroundColor: 'rgba(2, 62, 138, 0.1)',
                        borderWidth: 2,
                        fill: false,
                        tension: 0.4,
                        pointRadius: 3,
                        yAxisID: 'y',
                    },
                    {
                        label: 'Tiempo Actividades',
                        data: actividadesTimeData,
                        borderColor: '#00afb9', // Verdigris
                        backgroundColor: 'rgba(0, 175, 185, 0.1)',
                        borderWidth: 2,
                        fill: false,
                        tension: 0.4,
                        pointRadius: 3,
                        yAxisID: 'y',
                    },
                    {
                        label: 'Actividades Realizadas',
                        data: actividadesCountData,
                        type: 'bar',
                        backgroundColor: 'rgba(244, 162, 97, 0.6)', // Sandy Brown
                        borderColor: '#f4a261',
                        borderWidth: 1,
                        yAxisID: 'y1',
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                    mode: 'index',
                    intersect: false,
                },
                plugins: {
                    datalabels: {
                        display: false
                    },
                    legend: { display: true },
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                if (context.dataset.yAxisID === 'y') {
                                    return context.dataset.label + ': ' + timeFormatter(context.raw as number);
                                } else {
                                    return context.dataset.label + ': ' + context.raw;
                                }
                            }
                        }
                    }
                },
                scales: {
                    y: {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        beginAtZero: true,
                        max: maxValTime > 0 ? maxValTime : undefined,
                        title: { display: true, text: 'Tiempo', color: '#023e8a' },
                        ticks: {
                            color: '#023e8a',
                            maxTicksLimit: 3,
                            stepSize: maxValTime > 0 ? maxValTime / 2 : undefined,
                            callback: (value) => timeFormatter(Number(value))
                        }
                    },
                    y1: {
                        type: 'linear',
                        display: true,
                        position: 'right',
                        beginAtZero: true,
                        max: maxValCount > 0 ? maxValCount : undefined,
                        title: { display: true, text: 'Actividades (unidades)', color: '#f4a261' },
                        grid: { drawOnChartArea: false },
                        ticks: {
                            color: '#f4a261',
                            maxTicksLimit: 3,
                            stepSize: maxValCount > 0 ? maxValCount / 2 : undefined,
                            callback: (value) => Math.floor(Number(value))
                        }
                    },
                    x: {
                        grid: {
                            color: (context) => {
                                if (context.tick && typeof context.tick.value === 'number') {
                                    const day = context.tick.value + 1;
                                    if (this.currentYear && this.currentMonth) {
                                        const date = new Date(this.currentYear, this.currentMonth - 1, day);
                                        if (date.getDay() === 0) return '#555555';
                                    }
                                }
                                return 'rgba(0, 0, 0, 0.1)';
                            },
                            // @ts-ignore
                            borderDash: (context) => {
                                if (context.tick && typeof context.tick.value === 'number') {
                                    const day = context.tick.value + 1;
                                    if (this.currentYear && this.currentMonth) {
                                        const date = new Date(this.currentYear, this.currentMonth - 1, day);
                                        if (date.getDay() === 0) return [5, 5];
                                    }
                                }
                                return [];
                            }
                        }
                    }
                }
            }
        });
    }

    renderEditorSpecificChart(index: number, user: any) {
        if (!user.tiempoActivoDiario_ms) return; // Basic check

        const canvasId = 'chart-user-1-' + index;
        const canvas = document.getElementById(canvasId) as HTMLCanvasElement;

        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        // Prepare data helper
        const monthShort = this.currentMonthLabel ? this.currentMonthLabel.substring(0, 3).toLowerCase() : '';
        const days = Array.from({ length: user.tiempoActivoDiario_ms.length }, (_, i) => `${i + 1}-${monthShort}`);
        const getSafeData = (arr: any[]) => arr ? arr.map(v => v || 0) : new Array(days.length).fill(0);

        const proyectos = getSafeData(user.proyectosCreadosDiarios);
        const grafos = getSafeData(user.grafosCreadosDiarios);
        const ideas = getSafeData(user.ideasCreadasDiarias);
        const actividades = getSafeData(user.actividadesCreadasDiarias);

        const maxVal = Math.max(...proyectos, ...grafos, ...ideas, ...actividades);

        new Chart(ctx, {
            type: 'bar',
            data: {
                labels: days,
                datasets: [
                    {
                        label: 'Proyectos',
                        data: proyectos,
                        backgroundColor: 'rgba(231, 111, 81, 0.6)', // Burnt Sienna
                        borderColor: '#e76f51',
                        borderWidth: 1,
                        yAxisID: 'y',
                    },
                    {
                        label: 'Ideógrafos',
                        data: grafos,
                        backgroundColor: 'rgba(244, 162, 97, 0.6)', // Sandy Brown
                        borderColor: '#f4a261',
                        borderWidth: 1,
                        yAxisID: 'y',
                    },
                    {
                        label: 'Ideas',
                        data: ideas,
                        backgroundColor: 'rgba(233, 196, 106, 0.6)', // Maize
                        borderColor: '#e9c46a',
                        borderWidth: 1,
                        yAxisID: 'y',
                    },
                    {
                        label: 'Actividades',
                        data: actividades,
                        backgroundColor: 'rgba(42, 157, 143, 0.6)', // Persian Green (Teal - warmish relative to blues)
                        borderColor: '#2a9d8f',
                        borderWidth: 1,
                        yAxisID: 'y',
                    }
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                    mode: 'index',
                    intersect: false,
                },
                plugins: {
                    datalabels: {
                        display: false
                    },
                    legend: { display: true },
                    tooltip: {
                        callbacks: {
                            label: (context) => context.dataset.label + ': ' + context.raw
                        }
                    }
                },
                scales: {
                    y: {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        beginAtZero: true,
                        max: maxVal > 0 ? maxVal : undefined,
                        title: { display: true, text: 'Creaciones (unidades)', color: '#e76f51' },
                        ticks: {
                            color: '#e76f51',
                            maxTicksLimit: 3,
                            stepSize: maxVal > 0 ? maxVal / 2 : undefined,
                            callback: (value) => Math.floor(Number(value))
                        }
                    },
                    x: {
                        grid: {
                            color: (context) => {
                                if (context.tick && typeof context.tick.value === 'number') {
                                    const day = context.tick.value + 1;
                                    if (this.currentYear && this.currentMonth) {
                                        const date = new Date(this.currentYear, this.currentMonth - 1, day);
                                        if (date.getDay() === 0) return '#555555';
                                    }
                                }
                                return 'rgba(0, 0, 0, 0.1)';
                            },
                            // @ts-ignore
                            borderDash: (context) => {
                                if (context.tick && typeof context.tick.value === 'number') {
                                    const day = context.tick.value + 1;
                                    if (this.currentYear && this.currentMonth) {
                                        const date = new Date(this.currentYear, this.currentMonth - 1, day);
                                        if (date.getDay() === 0) return [5, 5];
                                    }
                                }
                                return [];
                            }
                        }
                    }
                }
            }
        });

        // Update Chart Data with correct dataset array
        // (I will do this by clean replacement in the actual tool call below)
    }

    /**MENSAJES DE LA PANTALLA DE CARGA */
    iniciarCambioMensajes() {
        this.cambiarMensaje(); // Mostrar el primer mensaje de inmediato

        this.intervaloMensajes = setInterval(() => {
            this.cambiarMensaje();
        }, this.obtenerTiempoAleatorio());
    }

    cambiarMensaje() {
        const indice = Math.floor(Math.random() * this.mensajes.length);
        this.mensajeActual = this.mensajes[indice];
    }

    obtenerTiempoAleatorio(): number {
        // entre 1000ms y 3000ms
        return Math.floor(Math.random() * (3000 - 1000 + 1)) + 1000;
    }

    cancelarLoading() {
        this.loading = false;
        this.unsubscribe$.next();
    }

    /**FIN MENSAJES DE LA PANTALLA DE CARGA */
}
